import React, { FC } from 'react';

import * as ScrollArea from '@radix-ui/react-scroll-area';
import clsx from 'clsx';

import styles from './StyledScrollArea.module.scss';

type ClassKey = 'root' | 'viewport';

export type StyledScrollAreaProps = {
    classes?: Classes<ClassKey>;
};

export const StyledScrollArea: FC<StyledScrollAreaProps> = (props) => {
    const { classes, children } = props;

    return (
        <ScrollArea.Root className={clsx(styles.scrollArea, classes?.root)}>
            <ScrollArea.Viewport className={clsx(styles.viewport, classes?.viewport)}>
                {children}
            </ScrollArea.Viewport>
            <ScrollArea.Scrollbar orientation="vertical" className={styles.scrollbar} forceMount>
                <ScrollArea.Thumb className={styles.thumb} />
            </ScrollArea.Scrollbar>
            <ScrollArea.ScrollAreaScrollbar
                orientation="horizontal"
                className={styles.scrollbar}
                forceMount
            >
                <ScrollArea.Thumb className={styles.thumb} />
            </ScrollArea.ScrollAreaScrollbar>
        </ScrollArea.Root>
    );
};
